const initialState = {
    statusShow: false,
    price: '',
};
const modalGratuity = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_HANDEL_MODAL_ADD_GRATUITY':
            return {...state, statusShow:  action.statusShow};
        case 'CHANGE_INPUTS_MODAL_ADD_GRATUITY':
            return {...state,[action.name]:action.value};
        default:
            return state;
    }
};

export default modalGratuity;
